<image-upload *ngIf="transfer"
              [image]="transfer?.image"
              [uploading]="transfer?.uploading"
              (clippingChange)="transfer?.clippingChange?.emit($event)"
              (fileChange)="transfer?.fileChange?.emit($event)"
              (deletePress)="transfer?.deletePress?.emit()">
</image-upload>
